module.exports = __webpack_public_path__ + "img/sameday_dg_k.eb310ff5.png";